var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorWrapper',{attrs:{"file-id":_vm.fileid,"relative-path":_vm.filename,"active":_vm.active,"autofocus":_vm.autofocus,"share-token":_vm.shareToken,"mime":_vm.mime}})}
var staticRenderFns = []

export { render, staticRenderFns }